{
  const BaseModule = require('_base/base')

  class Screenshot extends BaseModule {
    preInit() {
      this.isAffectingHeight = true
    }

    postInit() {
      this.$deviceViewport = this.$el.find('.browser-viewport')
      this.ratio = this.$el.data('ratio')
    }

    preCalculate() {
      this.deviceViewportWidth = this.$deviceViewport.innerWidth()
    }

    calculateHeight() {
      return Math.round(this.deviceViewportWidth * this.ratio)
    }

    setMinHeight() {
      this.$deviceViewport.css({ 'min-height': this.calculateHeight() })
    }

    preRender() {
      this.setMinHeight()
    }
  }

  $('.browser[data-ratio]').each((_, el) => {
    new Screenshot($(el))
  })
}
